<div class="card">
  <div class="card-header-white rounded-corners cursorPointer" data-testid="header" (click)="loadActiveAlerts()">
    <h6 style="position: relative; top: 25%">
      {{ "ACTIVE_ALARMS" | translate }}
    </h6>
    <span
      class="fa-solid fa-xl float-right caretIcon"
      [ngClass]="panelOpen ? 'fa-chevron-up' : 'fa-chevron-down'">
    </span>
  </div>
  @if (panelOpen) {
    <div class="card-body-white" data-testid="body" [@animationCollapseLeave]>
      @if (!activeAlerts || !activeAlertsLoaded) {
        <div>
          @if (!activeAlertsLoaded) {
            <img
              class="fadeLoader centerLoader logoSmall"
              src="assets/img/loading_logo.svg"
              />
          }
          @if (activeAlertsLoaded && !activeAlertsLoadError) {
            <span class="d-block mt-2" data-testid="no-alarms">{{ "NO_ALARMS" | translate }}</span>
          }
          @if (activeAlertsLoaded && activeAlertsLoadError) {
            <div class="mt-2" data-testid="load-error">
              <span class="text-danger d-block">{{ "ERROR" | translate }}</span>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" data-testid="retry-button"
                (click)="retryActiveAlerts()">
                <span class="fa-light fa-fw fa-arrows-rotate"></span> {{ "REFRESH" | translate }}
              </button>
            </div>
          }
        </div>
      }
      @if (activeAlerts) {
        <div class="activeAlertsTable" [@animationCollapse]>
          <table class="table table-hover">
            <thead>
              <tr>
                <th style="width: 1%"></th>
                <th style="width: 1%"></th>
                <th>
                  {{ "ALARM_REGISTERED" | translate }}
                </th>
                @if (showCustomer) {
                  <th>{{ "CUSTOMER" | translate }}</th>
                }
                <th>{{ "DEVICE" | translate }}</th>
                <th>{{ "ALARM_TYPE" | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (alert of activeAlerts; track alert) {
                <tr class="alertRow" (click)="toggleExpand(alert.taskId)">
                  <td>
                    <span class="fa-light fa-fw expandIcon" [ngClass]="expandedAlertId === alert.taskId ? 'fa-chevron-down' : 'fa-chevron-right'"></span>
                  </td>
                  <td>
                    <span class="fa-light fa-fw" [ngClass]="alert | deliveryClass"></span>
                  </td>
                  <td>{{ alert.receiveTime | moment : "l LTS" }}</td>
                  @if (showCustomer) {
                    <td>{{ alert.customerName }}</td>
                  }
                  <td>{{ alert.deviceName ? alert.deviceName : alert.deviceId }}</td>
                  <td>
                    {{
                    getActivationName(
                    alert.activationGroup,
                    alert.activationNode,
                    alert.deviceType,
                    alert.customActivationName,
                    alert.connTimeLimit
                    )
                    }}
                  </td>
                  <td>
                    <!-- Cancelling needs Dashboard.CancelAlert ReadWrite (every built-in role has it), or cancelAllowed -->
                    @if (!alert.cancelled && !alert.error && (cancelAllowed ?? (Areas.DashboardCancelAlert | can: 'ReadWrite'))) {
                      <button data-testid="cancel-button" class="btn btn-outline-dark danger-text fullWidth" (click)="$event.stopPropagation(); cancelAlert(alert)">
                        <span class="fa-light fa-circle-stop"></span>
                        {{ "CANCEL_DELIVERY" | translate}}
                      </button>
                    }
                    @if (alert.cancelled) {
                      <span class="danger-text">{{ "DELIVERY_CANCELLED" | translate }}</span>
                    }
                    @if (alert.error) {
                      <span class="danger-text">{{ "ERROR" | translate }}</span>
                    }
                  </td>
                </tr>
                @if (expandedAlertId === alert.taskId) {
                  <tr class="alertDetailRow" data-testid="detail-row">
                    <td colspan="6">
                      <div class="alertDetailPanel">
                        <div class="alertDetailItem ml-5">
                          <span class="alertDetailLabel">{{ "TASK_ID" | translate }}</span>
                          <span class="alertDetailValue">{{ alert.taskId }}</span>
                        </div>
                        <div class="alertDetailItem">
                          <span class="alertDetailLabel">{{ "DELIVERY_TYPE" | translate }}</span>
                          <span class="alertDetailValue">{{ alert.deliveryType }}</span>
                        </div>
                        @if (alert.callCount >= 1) {
                          <div class="alertDetailItem">
                            <span class="alertDetailLabel">{{ "CALL_COUNT" | translate }}</span>
                            <span class="alertDetailValue">{{ alert.callCount }}</span>
                          </div>
                        }
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
</div>
